<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'

const props = defineProps({
  phrases: {
    type: Array,
    required: true,
  },
  typeSpeed: {
    type: Number,
    default: 55,
  },
  pause: {
    type: Number,
    default: 5000,
  },
  randomStart: {
    type: Boolean,
    default: true,
  },
  cursor: {
    type: Boolean,
    default: true,
  },
})

const displayed = ref('')
let index = 0
let typeTimer = null
let pauseTimer = null

const stop = () => {
  clearInterval(typeTimer)
  clearTimeout(pauseTimer)
}

const typeCurrent = () => {
  const text = props.phrases[index] ?? ''
  displayed.value = ''
  let typed = 0
  clearInterval(typeTimer)
  typeTimer = setInterval(() => {
    displayed.value = text.slice(0, ++typed)
    if (typed >= text.length) {
      clearInterval(typeTimer)
      if (props.phrases.length > 1) {
        pauseTimer = setTimeout(() => {
          index = (index + 1) % props.phrases.length
          typeCurrent()
        }, props.pause)
      }
    }
  }, props.typeSpeed)
}

const start = () => {
  stop()
  if (!props.phrases.length) return
  index = props.randomStart ? Math.floor(Math.random() * props.phrases.length) : 0
  typeCurrent()
}

onMounted(start)
onBeforeUnmount(stop)
watch(() => props.phrases, start)
</script>

<template>
  <span><span>{{ displayed }}</span><span
    v-if="cursor"
    class="type-cursor"
  /></span>
</template>

<style scoped lang="scss">
.type-cursor {
  display: inline-block;
  width: 1px;
  height: 1.1em;
  margin-left: 0.125rem;
  vertical-align: text-bottom;
  background: currentColor;
  animation: type-cursor-blink 1s steps(1) infinite;
}
@keyframes type-cursor-blink {
  50% {
    opacity: 0;
  }
}
</style>
